<div theme class="session-espired-container">
    <div fxLayout="column" fxLayoutAlign="center center">
        <i cdkFocusInitial class="far fa-clock session-expired-clock"></i>
        <p class="error-title-text" cdkFocusInitial>Your session has expired</p>
        <p class="error-message-text">Please log in again to continue</p>
        <button mat-button class="login-btn" (click)="login()">Login Now</button>
        <p class="error-message-text">-- (or) --</p>
        <u class="retry-text" (click)="withOutLogin()">Continue without login</u>
    </div>
</div>